var _defs, _rect, _polygon, _polygon2, _path, _polygon3, _polygon4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-4-1{fill:#c5192d;}.cls-4-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sdg4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4-1",
    x: -0.92,
    y: -0.48,
    width: 51.07,
    height: 51.07
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4-2",
    points: "20.54 18.08 7.94 10.81 7.94 34.34 20.54 38.15 20.54 18.08"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4-2",
    points: "21.93 18.13 21.93 38.15 34.61 34.34 34.61 10.81 21.93 18.13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-2",
    d: "M44.5,10.21a1.49,1.49,0,1,0-3,0v1.61h3Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4-2",
    points: "41.89 33.93 41.52 33.93 43.01 39.14 44.5 33.93 44.13 33.93 44.5 33.93 44.5 12.99 44.13 12.99 43.76 12.99 43.37 12.99 42.63 12.99 42.26 12.99 41.89 12.99 41.52 12.99 41.52 33.93 41.89 33.93"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4-2",
    points: "37.31 11.82 35.97 10.75 35.97 34.98 21.96 39.51 21.32 39.51 21.19 39.51 20.54 39.51 6.6 35.61 6.6 10.75 5.25 11.82 5.25 36.56 20.48 40.77 21.19 40.77 21.32 40.77 22.03 40.77 36.08 36.31 37.31 35.95 37.31 11.82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdg4);
export default __webpack_public_path__ + "static/media/sdg4.ed6f1675866c4ea72c2332a0ccd03af2.svg";
export { ForwardRef as ReactComponent };